import { Divider, Grid } from '@mui/material';
import { useGetChatToUpdate } from '../../../../../../services/modules/chats/chats.queries';
import ChatRoomForm from '../../../ChatRoomForm/ChatRoomForm';
import { useChatMessagesContext } from '../../contexts/chatMessages.context';
import EditChatFormHeader from './components/EditChatFormHeader/EditChatFormHeader';

interface EditChatViewProps {
  chatId: string;
}

const EditChatView = ({ chatId }: EditChatViewProps) => {
  const { goToChat } = useChatMessagesContext();
  const { data: initialValues } = useGetChatToUpdate(chatId);

  return (
    <Grid container test-id="edit-chat-message-view-wrapper">
      <Grid size={12}>
        <EditChatFormHeader />
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>
      <Grid size={12}>
        <ChatRoomForm chatId={chatId} onSuccess={goToChat} initialValues={initialValues} />
      </Grid>
    </Grid>
  );
};

export default EditChatView;
